import { getToken } from "firebase/messaging";
import { messaging } from "../firebase";

export async function registerWebPush() {
  const permission = await Notification.requestPermission();

  if (permission !== "granted") {
    return null;
  }

  const token = await getToken(messaging, {
    vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
  });

  return token;
}
